import React from "react";
import { Row, Col, Button, Divider, Modal, Select } from "antd";
import Scrollbars from "react-custom-scrollbars";
import db from "../../../../database";
import useRestaurantStore from "../../../../stores/useRestaurantStore";

const { Option } = Select;

const SplitBillModal = ({
  showSplitBill,
  setShowSplitBill,
  cart,
  setCart,
  numSplits,
  setNumSplits,
  currenciesList,
  pricePrecision,
  toFixedTruncate,
  serviceChargeAmount,
  tipTotal,
  deliveryChargeAmount,
  packingChargeAmount,
  totalSplits,
  taxSplits,
  setIsSplitBill,
  setSplitCarts,
  setCurrentSplitIndex,
  setSplitBillScreen,
  setShowAllItems,
  setGroupedItems,
}) => {
  return (
    <Modal
      centered
      open={showSplitBill}
      closable={false}
      footer={null}
      style={{ borderRadius: "10px" }}
      styles={{ body: { padding: "10px" } }}
      modalRender={(modal) => (
        <div
          style={{
            borderRadius: "10px",
            overflow: "hidden",
            height: "66vh",
            width: "90%",
          }}
        >
          {React.cloneElement(modal, {
            style: {
              ...modal.props.style,
              borderRadius: "10px",
              overflow: "hidden",
            },
          })}
        </div>
      )}
    >
      <div style={{ padding: "5px 10px 5px 10px" }}>
        <Row>
          <Col span={10} style={{ display: "flex", alignItems: "center", justifyContent: "left", color: "#0F0718", fontWeight: 500, fontSize: "1.5em", fontWeight: 600 }}>
            Current Order
          </Col>
          <Col span={14} style={{ fontSize: "1em", color: "#0F0718", fontWeight: 500, display: "flex", alignItems: "center", justifyContent: "center" }}>
            Number of Splits
            <Select
              size="small"
              value={numSplits}
              style={{ width: 100, border: "1px solid #ccc", marginLeft: "0.5vw", borderRadius: "5px" }}
              onChange={(value) => {
                setNumSplits(value);
              }}
            >
              {[2, 3, 4, 5, 6].map((num) => (
                <Option key={num} value={num}>
                  {num} {"People"}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row justify="space-between" style={{ marginBottom: 12 }}>
          <Col span={12}>
            <p style={{ color: "#929098", fontSize: "1em", fontWeight: 500, marginBottom: 0 }}>
              {cart?.tableNo} - {cart?.documentno}
            </p>
          </Col>
        </Row>
        <Scrollbars autoHide style={{ height: "30vh" }}>
          <Row style={{ fontSize: "1vw" }}>
            {cart?.items?.map((item, index) => (
              <React.Fragment key={index}>
                <Col span={12} style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 400, paddingBottom: "6px" }}>
                  {item.weight}x {item?.productAliasName ? item?.productAliasName : item.name}
                </Col>
                <Col
                  span={12}
                  style={{
                    fontSize: "1.1em",
                    color: "#0F0718",
                    fontWeight: 400,
                    paddingBottom: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "right",
                    paddingRight: "10px",
                  }}
                >
                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                  {toFixedTruncate(item.nettotal, pricePrecision)}
                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </Scrollbars>

        <Divider style={{ margin: "12px 0" }} />
        <Row>
          <Col span={12} style={{ display: "flex", alignItems: "center", justifyContent: "left", color: "#0F0718", fontSize: "1.2em", fontWeight: 500 }}>
            Total:
          </Col>
          <Col span={12} style={{ display: "flex", alignItems: "center", justifyContent: "right", color: "#0F0718", fontSize: "1.2em", fontWeight: 500 }}>
            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
            {toFixedTruncate(cart?.total + serviceChargeAmount + tipTotal + deliveryChargeAmount + packingChargeAmount, pricePrecision)}
            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
          </Col>
        </Row>

        <Row justify="center" gutter={16} style={{ marginTop: "1.8vh" }}>
          <Col span={12}>
            <Button
              style={{ width: "100%", border: "1px solid #92909880", borderRadius: "5px", color: "#0F0718", height: "5.5vh" }}
              onClick={() => {
                setShowSplitBill(false);
                setIsSplitBill(false);
                setSplitCarts([]);
                setCurrentSplitIndex(0);
                setSplitBillScreen(false);
                setNumSplits(2);
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button
              style={{ width: "100%", border: "1px solid #92909880", borderRadius: "5px", color: "#fff", backgroundColor: "#2F3856", height: "5.5vh" }}
              type="primary"
              onClick={async () => {
                const splitCarts = Array.from({ length: numSplits }, (_, i) => {
                  const splitItems = cart.items.map((item) => ({
                    ...item,
                    nettotal: Number(toFixedTruncate(item.nettotal / numSplits, pricePrecision)),
                    total: Number(toFixedTruncate(item.total / numSplits, pricePrecision)),
                    grosslist: Number(toFixedTruncate(item.grosslist / numSplits, pricePrecision)),
                    linegross: Number(toFixedTruncate(item.linegross / numSplits, pricePrecision)),
                    linenet: Number(toFixedTruncate(item.linenet / numSplits, pricePrecision)),
                    sunitprice: Number(toFixedTruncate(item.sunitprice / numSplits, pricePrecision)),
                  }));
                  return {
                    ...cart,
                    documentno: `${cart.documentno} - ${i + 1}`,
                    items: splitItems,
                    total: totalSplits[i],
                    tax: taxSplits[i],
                    subTotal: totalSplits[i] - taxSplits[i],
                    tableNo: useRestaurantStore.getState().dineIn === "Y" ? cart.tableNo : "",
                    splitNo: i + 1,
                    isSplit: "Y",
                  };
                });
                const categories = await db.productCategories.toArray();
                const groupedItemsByCategory = categories
                  .map((cat) => {
                    const items = cart?.items?.filter((item) => item.mProductCategoryId === cat.mProductCategoryId);

                    return {
                      category: cat.name,
                      categoryId: cat.mProductCategoryId,
                      items,
                    };
                  })
                  .filter((group) => group.items.length > 0);
                setGroupedItems(groupedItemsByCategory);
                setSplitCarts(splitCarts);
                setIsSplitBill(true);
                setCurrentSplitIndex(0);
                setSplitBillScreen(true);
                setShowSplitBill(false);
                setShowAllItems(true);
              }}
            >
              Split Bill
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default SplitBillModal;
